<template>
    <ui-box eager :form="$refs[formRef]">
      <form-title :title="title">
        {{ description }}
        <template #button>
          <div class="d-flex align-center h-100">
            <v-btn
              class="mt-1 rounded-lg mr-2"
              color="primary"
              depressed
              outlined
              small
              @click="$emit('send-test')"
            >
              <v-icon>mdi-arrow-top-right</v-icon>
              Send Test
            </v-btn>
            <v-btn
              class="mt-1 rounded-lg"
              color="secondary"
              depressed
              outlined
              small
              @click="$emit('add-message')"
            >
              <v-icon>mdi-plus</v-icon>
              Add Email
            </v-btn>
          </div>
        </template>
      </form-title>
      <v-divider class="mb-8 mt-4 opacity-80"></v-divider>
      <v-row v-if="loading">
        <v-col>
          <v-progress-circular
            color="primary"
            indeterminate
            width="2"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row v-if="!loading && sequence?.drips?.length">
        <v-col>          
          <v-row>
            <v-col>
              <v-row v-if="sequence.name">
                <v-col>
                  <h6 class="mb-4">{{ sequence.name }}</h6>
                </v-col>
              </v-row>
              <template v-for="(drip, dripIdx) in sequence.drips">
                <v-row :key="`drip-${dripIdx}`">
                  <v-col cols="auto">
                    <v-switch
											v-model="drip.active"
                      class="mt-1 mr-n4 pt-0"
                      dense
                      hide-details="auto"
                      inset
											@change="$emit('active-change', dripIdx, drip.active)"
                    ></v-switch>
                  </v-col>
                  <v-col>
                    <div class="d-block">
                      <span class="font-weight-medium">Email {{ drip.message.index }}</span>
                      -
                      <span class="primary--text">{{ formatInterval(dripIdx) }}</span>
                    </div>
                    {{ drip.message.subject }}
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      class="mx-2"
                      color="secondary"
                      outlined
                      depressed
                      fab
                      small
                      @click="$emit('show-message-preview', drip.message)"
                    >
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                    <v-btn
                      color="secondary"
                      outlined
                      depressed
                      fab
                      small
                      @click="$emit('edit-message', dripIdx)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="!loading && !sequence">
        <v-col>
          <h6>No Sequences</h6>
        </v-col>
      </v-row>
    </ui-box>
</template>

<script>
export default {
  name: "SequenceForm",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    firstInterval: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      required: true
    },
    ignoreFirstInterval: {
      type: Boolean,
      default: false
    },
    period: {
      type: String,
      default: 'day'
    },
    sequence: {
      type: Object,
      required: false,
			default: () => {}
    },
    formRef: {
      type: String,
      required: true
    }
  },
  methods: {
    formatInterval(dripIdx) {
      if (this.ignoreFirstInterval && dripIdx === 0) {
        return this.firstInterval;
      };

      const { sequence: { drips } } = this;

      const interval = dripIdx === (this.ignoreFirstInterval ? 1 : 0)
        ? drips[dripIdx].interval
        : drips[dripIdx].interval - drips[dripIdx-1].interval;

      const { period } = this;
      const s = interval > 1 ? 's' : '';
      const unit = period === 'hour' ? 'hr' : period;
      const suffix = this.ignoreFirstInterval || dripIdx > 0
        ? 'after previous email'
        : 'after the onboarding begins';

      return `Send ${interval} ${unit}${s} ${suffix}`;
    }
  }
};
</script>
